import Lottie from 'lottie-react';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import animationData from '../../../assets/json/loader.json';

interface SuspenseProps {
    isLoading: boolean;
    isError: boolean;
    errorFallback?: ReactNode;
    className?: string;
}
const SuspenseCustom: FC<PropsWithChildren<SuspenseProps>> = ({
    isLoading,
    isError,
    errorFallback,
    children,
    className,
}) => {
    if (isLoading) {
        return (
            <div className={twMerge('flex items-center justify-center h-full w-full', className)}>
                <div className="h-16 w-36 -mt-12">
                    <Lottie animationData={animationData} loop={true} />
                </div>
            </div>
        );
    }
    if (isError) {
        if (errorFallback) {
            return <>{errorFallback}</>;
        }
        console.warn('An error occurred while loading the component. Please try again later.');
        return null;
    }
    if (children === undefined || typeof children !== 'object') {
        console.warn('Suspense component expects children to be a valid React element.');
        return null;
    }
    return <>{children}</>;
};

export default SuspenseCustom;
